import Axios from '@/plugins/axios'
import { onlineUrl } from '@/utils/config';
// 广告位
export function getadvanceoption() {
  const config = {
    url: `${onlineUrl}/mk-leads/search/product/init-advance-option-data`,
    method: 'POST',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
  }
  return Axios(config);
}

// 分页查询合作伙伴询盘列表
export function partnerRfqQuery(data) {
  const config = {
    url: `${onlineUrl}/mk-rfq-api/partner/rfq/query-page`,
    method: 'POST',
    data:data
  }
  return Axios(config);
}

// 初始化
export function initSearchCondition() {
  const config = {
    url: `${onlineUrl}/mk-rfq-api/partner/rfq/init-search-condition`,
    method: 'GET',
  }
  return Axios(config);
}

// 查询合作伙伴询盘详情
export function partnerRfqDetail(rfqId) {
  const config = {
    url: `${onlineUrl}/mk-rfq-api/partner/rfq/detail/${rfqId}`,
    method: 'GET',
  }
  return Axios(config);
}

// 询盘详情-图纸在线协作
export function getOnlineDrawing (data) {
  return Axios({
    url: `${onlineUrl}/draw-online/access-rfq`,
    method: "POST",
    data,
  });
};

// 伙伴供应商申请接受 NDA1
export function applyOneNda (data) {
  return Axios({
    url: `${onlineUrl}/mk-rfq-api/partner/rfq/quote/apply-one-nda`,
    method: "POST",
    data: data
  });
};

// 记录行为动态
export function behaviorActive(params) {
  const config = {
    url: `${onlineUrl}/mk-leads/user/click-log`,
    method: "POST",
    data: params
  };
  return Axios(config);
}

// 获取入驻进度
export function onboardingProgres(params) {
  const config = {
    url: `${onlineUrl}/mk-leads/supplier/partner/onboarding-progress`,
    method: "POST",
    data: params
  };
  return Axios(config);
}

// 专区联系人信息
export function clientContact(source) {
  const config = {
    url: `${onlineUrl}/mk-rfq-api/partner/common/client-contact/${source}`,
    method: "POST",
  };
  return Axios(config);
}

// 伙伴供应商校验完成度
export function quoteCompleteness() {
  const config = {
    url: `${onlineUrl}/mk-rfq-api/partner/rfq/quote/completeness`,
    method: "POST",
  };
  return Axios(config);
}
// 伙伴供应商校验完成度
export function getCustomAttachment(data) {
  const config = {
    url: `${onlineUrl}/mk-rfq-api/partner/rfq/quote/get-rfq-two-nda`,
    method: "POST",
    data
  };
  return Axios(config);
}
// 查询授权按钮显示状态
export function getAuthBtnStatus(data) {
  const config = {
    url: `${onlineUrl}/mk-rfq-api/partner/authorization-status`,
    method: "POST",
    data
  };
  return Axios(config);
}